import React from 'react';

import { SpaceBetween, Popover, StatusIndicator, Button, Box, Select } from '@amzn/awsui-components-react-v3';

import { ValueWithLabel } from 'src/components/Utils';

const BUILD_CATEGORY_OPTIONS = [
  { label: 'DCO_SPARE', value: 'DCO_SPARE' },
  { label: 'BUILD', value: 'BUILD' },
];

interface BuildCategoryProps {
  processing: boolean;
  selectedCategory: string;
  handleCategoryChange: (option: { label: string; value: string }) => void;
  show: boolean;
}

export const BuildCategory = ({ processing, selectedCategory, handleCategoryChange, show }: BuildCategoryProps) => {
  if (!show) {
    return null;
  }

  return (
    <ValueWithLabel
      label={
        <SpaceBetween direction="horizontal" size="xxxs">
          <Popover
            dismissButton={false}
            position="top"
            size="small"
            triggerType="custom"
            content={<StatusIndicator type="info">Category</StatusIndicator>}
          >
            <Button ariaLabel="receiving-model-build-category" iconName="status-info" variant="icon" />
          </Popover>
          <Box variant="awsui-key-label">Category </Box>
          <Box variant="span" color="text-status-error">
            *
          </Box>
        </SpaceBetween>
      }
    >
      <Box margin={{ left: 'l' }}>
        <div style={{ width: '200px' }} id="build-category">
          <Select
            selectedOption={{ label: selectedCategory, value: selectedCategory }}
            onChange={({ detail }) => handleCategoryChange(detail.selectedOption)}
            placeholder="Choose a Category"
            selectedAriaLabel={`Selected category ${selectedCategory}`}
            ariaLabel="select build category"
            options={BUILD_CATEGORY_OPTIONS}
            disabled={processing}
          />
        </div>
      </Box>
    </ValueWithLabel>
  );
};
